import { API_URL } from './apiConfig'; // Import API_URL from your configuration file
async function CSRFToken(cookies) {
  try {
      const splitCookies = cookies.split('; ');
      const csrfCookie = splitCookies.find(cookie => cookie.startsWith("csrftoken="));
      
      if (csrfCookie) {
          return csrfCookie.split('=')[1];
      } else {
          // Call API to retrieve CSRF token
          const response = await fetch(`${API_URL}/csrf`);
          const data = await response.json();
          return data.csrf_token; // Adjust accordingly based on your API response
      }
  } catch (error) {
      console.error('Error retrieving CSRF token:', error);
      // Handle error appropriately, e.g., log error, return default value, etc.
      return 'default_csrf_token';
  }
}

export default CSRFToken;
